// extracted by mini-css-extract-plugin
export var footLine = "footer_m-module--foot-line--6577c";
export var footTop = "footer_m-module--foot-top--6a3f1";
export var footTopAddress = "footer_m-module--foot-top-address--94c3d";
export var footTopDesc = "footer_m-module--foot-top-desc--68a2a";
export var footTopText = "footer_m-module--foot-top-text--93019";
export var footerM = "footer_m-module--footer-m--3b47f";
export var footerNavItem = "footer_m-module--footer-nav-item--3a9f3";
export var footerNavs = "footer_m-module--footer-navs--40d86";
export var minWidthLimit = "footer_m-module--min-width-limit--0ff9f";